/**
 * Public identifiers of the back office's Datadog RUM application, shared by
 * RUM (`main.tsx`) and the feature flag provider (`featureFlags.ts`). The
 * client token is meant to ship to the browser.
 */
export const DATADOG = {
  applicationId: '65e95c4e-66b8-4504-9704-7106841826b0',
  clientToken: 'pub34d430ba5ce7bf2e58ba2c88cdbb875c',
  site: 'datadoghq.eu',
  service: 'plethore-admin-bo',
} as const
